import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/info.svg'


const _hoisted_1 = { class: "sq-calc-form main-cont" }
const _hoisted_2 = { class: "main-fields" }
const _hoisted_3 = { class: "level" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = {
  key: 0,
  class: "warn-text"
}
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "level" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "block" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1)
const _hoisted_16 = { class: "block" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1)
const _hoisted_18 = { class: "block" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1)
const _hoisted_20 = { class: "block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1)
const _hoisted_22 = { class: "block" }
const _hoisted_23 = { class: "additional-fields" }
const _hoisted_24 = { class: "level" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "block" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = { class: "block" }
const _hoisted_30 = { class: "level" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "block" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_35 = { class: "block" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_38 = { class: "text" }
const _hoisted_39 = { class: "block" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_41 = { class: "block" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_44 = { class: "btn-block" }
const _hoisted_45 = { class: "download-block" }
const _hoisted_46 = { class: "text-block" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "progress-block" }
const _hoisted_50 = {
  key: 0,
  class: "table-block"
}
const _hoisted_51 = { class: "title" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  class: "header-icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  class: "header-icon",
  src: _imports_0,
  alt: "/"
}, null, -1)
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  class: "header-icon",
  src: _imports_0,
  alt: "/"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DealsModal = _resolveComponent("DealsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_config_provider, { locale: _ctx.locale }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form",
          ref: "calcFormRef",
          model: _ctx.calcForm,
          rules: _ctx.calcFormRules,
          "label-width": "180px",
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('main.dataSettings')), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.exchange')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "exchange-select",
                        modelValue: _ctx.calcForm.exchange,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calcForm.exchange) = $event)),
                        onChange: _cache[1] || (_cache[1] = (e) => _ctx.getSymbols(e))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.EXCHANGE_TEXT[_ctx.Exchange.BINANCE],
                            value: _ctx.Exchange.BINANCE
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.EXCHANGE_TEXT[_ctx.Exchange.BINANCE_FUTURES],
                            value: _ctx.Exchange.BINANCE_FUTURES
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.EXCHANGE_TEXT[_ctx.Exchange.OKX],
                            value: _ctx.Exchange.OKX
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.EXCHANGE_TEXT[_ctx.Exchange.OKX_FUTURES],
                            value: _ctx.Exchange.OKX_FUTURES
                          }, null, 8, ["label", "value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    class: "right-item",
                    label: `${_ctx.$t('main.fee')} %:`,
                    prop: "fee"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "short-input",
                        modelValue: _ctx.calcForm.fee,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calcForm.fee) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.symbol')}:`,
                    prop: "symbol"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_autocomplete, {
                        modelValue: _ctx.calcForm.symbol,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calcForm.symbol) = $event)),
                        "fetch-suggestions": _ctx.querySearchSymbol,
                        clearable: ""
                      }, null, 8, ["modelValue", "fetch-suggestions"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    class: "right-item",
                    label: `${_ctx.$t('main.direction')}:`,
                    prop: "direction"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "short-select",
                        modelValue: _ctx.calcForm.isShort,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.calcForm.isShort) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: 'Long',
                            value: false
                          }),
                          _createVNode(_component_el_option, {
                            label: 'Short',
                            value: true
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.calcForm.isShort && (_ctx.calcForm.exchange === _ctx.Exchange.BINANCE || _ctx.calcForm.exchange === _ctx.Exchange.OKX))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('main.shortIsNotSupported')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.time')}:`,
                    prop: "time"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.calcForm.time,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.calcForm.time) = $event)),
                        type: "datetimerange",
                        "range-separator": "-",
                        "start-placeholder": _ctx.$t('main.from'),
                        "end-placeholder": _ctx.$t('main.to'),
                        "default-value": [new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
                    new Date(new Date().getFullYear(), new Date().getMonth(), 1)]
                      }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "default-value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('main.squeezeSearchArea')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.timeframe')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.calcForm.timeframe,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.calcForm.timeframe) = $event)),
                        onChange: _ctx.onChangeTimeframe
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: '1m',
                            value: '1m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '3m',
                            value: '3m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '5m',
                            value: '5m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '15m',
                            value: '15m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '30m',
                            value: '30m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '1h',
                            value: '1h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '2h',
                            value: '2h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '4h',
                            value: '4h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '6h',
                            value: '6h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '8h',
                            value: '8h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '12h',
                            value: '12h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '1d',
                            value: '1d'
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    class: "right-item",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.oncePerCandle,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.calcForm.oncePerCandle) = $event)),
                        label: _ctx.$t('main.oncePerCandle')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.binding')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.LOW],
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.LOW]) = $event)),
                        label: _ctx.$t('main.low')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.HIGH],
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.HIGH]) = $event)),
                        label: _ctx.$t('main.high')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.OPEN],
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.OPEN]) = $event)),
                        label: _ctx.$t('main.open')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.CLOSE],
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.CLOSE]) = $event)),
                        label: _ctx.$t('main.close')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_form_item, { label: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.HL2],
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.HL2]) = $event)),
                        label: _ctx.$t('main.hl2')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.OC2],
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.OC2]) = $event)),
                        label: _ctx.$t('main.oc2')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.OHLC4],
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.OHLC4]) = $event)),
                        label: _ctx.$t('main.ohlc4')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.binding[_ctx.SqueezeBindings.HLC3],
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.calcForm.binding[_ctx.SqueezeBindings.HLC3]) = $event)),
                        label: _ctx.$t('main.hlc3')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.percentEnter')}:`,
                    prop: "percentEnterFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.percentEnterFrom,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.calcForm.percentEnterFrom) = $event)),
                        precision: 1,
                        step: 0.1,
                        min: 0.2,
                        onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.ispercentEnterSellWasManuallySet = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_15,
                  _createVNode(_component_el_form_item, { prop: "percentEnterTo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.percentEnterTo,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.calcForm.percentEnterTo) = $event)),
                        precision: 1,
                        step: 0.1,
                        min: 0.2,
                        onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.ispercentEnterSellWasManuallySet = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.percentExit')}:`,
                    prop: "percentExitFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.percentExitFrom,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.calcForm.percentExitFrom) = $event)),
                        precision: 1,
                        step: 0.1,
                        min: 0.2,
                        onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.ispercentEnterSellWasManuallySet = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_17,
                  _createVNode(_component_el_form_item, { prop: "percentExitTo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.percentExitTo,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.calcForm.percentExitTo) = $event)),
                        precision: 1,
                        step: 0.1,
                        min: 0.2,
                        onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.ispercentEnterSellWasManuallySet = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.stopLossTime.isActive,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.calcForm.stopLossTime.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.stopLossTime')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.stopLossTime.from,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.calcForm.stopLossTime.from) = $event)),
                        min: 0,
                        disabled: !_ctx.calcForm.stopLossTime.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_19,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.stopLossTime.to,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.calcForm.stopLossTime.to) = $event)),
                        min: 0,
                        disabled: !_ctx.calcForm.stopLossTime.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.stopLossPercent.isActive,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.calcForm.stopLossPercent.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.stopLossPercent')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.stopLossPercent.from,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.calcForm.stopLossPercent.from) = $event)),
                        min: 0,
                        disabled: !_ctx.calcForm.stopLossPercent.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_21,
                  _createVNode(_component_el_form_item, { prop: "stopLossTimeTo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.stopLossPercent.to,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.calcForm.stopLossPercent.to) = $event)),
                        min: 0,
                        disabled: !_ctx.calcForm.stopLossPercent.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_form_item, { label: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.stopOnKlineClosed,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.calcForm.stopOnKlineClosed) = $event)),
                        label: _ctx.$t('main.stopOnKlineClosed'),
                        disabled: !_ctx.calcForm.stopLossPercent.isActive
                      }, null, 8, ["modelValue", "label", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('main.filters')), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.minNumDeals.isActive,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.calcForm.minNumDeals.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.minNumDeals')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.minNumDeals.value,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.calcForm.minNumDeals.value) = $event)),
                        min: 0,
                        precision: 0,
                        step: 1,
                        disabled: !_ctx.calcForm.minNumDeals.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.minCoeff.isActive,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.calcForm.minCoeff.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.minCoeff')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.minCoeff.value,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.calcForm.minCoeff.value) = $event)),
                        min: 0,
                        precision: 1,
                        step: 0.1,
                        disabled: !_ctx.calcForm.minCoeff.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.minWinRate.isActive,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.calcForm.minWinRate.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.minWinRate')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.minWinRate.value,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.calcForm.minWinRate.value) = $event)),
                        min: 0,
                        max: 1,
                        precision: 2,
                        step: 0.01,
                        disabled: !_ctx.calcForm.minWinRate.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_el_form_item, { class: "is-active-checkbox" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.calcForm.maxSellBuyRatio.isActive,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.calcForm.maxSellBuyRatio.isActive) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `${_ctx.$t('main.maxSellBuyRatio')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.maxSellBuyRatio.value,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.calcForm.maxSellBuyRatio.value) = $event)),
                        min: 0,
                        precision: 2,
                        step: 0.01,
                        disabled: !_ctx.calcForm.maxSellBuyRatio.isActive
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('main.optimizationSettings')), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_el_form_item, {
                    class: "is-tooltip",
                    label: `${_ctx.$t('main.algorithm')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.algorithmTooltip')
                          }, null, 8, _hoisted_33)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.calcForm.algorithm,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.calcForm.algorithm) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.OptimizationAlgorithm.GRID,
                            value: _ctx.OptimizationAlgorithm.GRID
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.OptimizationAlgorithm.OMG,
                            value: _ctx.OptimizationAlgorithm.OMG
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_el_option, {
                            label: "Random",
                            value: _ctx.OptimizationAlgorithm.RANDOM
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_el_form_item, {
                    class: "is-tooltip",
                    label: `${_ctx.$t('main.iterations')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.iterationsTooltip')
                          }, null, 8, _hoisted_36)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.iterations,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.calcForm.iterations) = $event)),
                        min: 0
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.totalNumberVariants), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_el_form_item, {
                    class: "is-tooltip",
                    label: `${_ctx.$t('main.saveResults')}:`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        content: _ctx.$t('main.saveResultsTooltip'),
                        placement: "bottom",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.calcForm.saveResults,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.calcForm.saveResults) = $event)),
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_el_form_item, {
                    class: "is-tooltip",
                    label: `${_ctx.$t('main.downloadTimeFrame')}:`,
                    prop: "downloadTimeFrame"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.downloadTimeFrameTooltip')
                          }, null, 8, _hoisted_42)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.calcForm.downloadTimeFrame,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.calcForm.downloadTimeFrame) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: '1m',
                            value: '1m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '3m',
                            value: '3m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '5m',
                            value: '5m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '15m',
                            value: '15m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '30m',
                            value: '30m'
                          }),
                          _createVNode(_component_el_option, {
                            label: '1h',
                            value: '1h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '2h',
                            value: '2h'
                          }),
                          _createVNode(_component_el_option, {
                            label: '4h',
                            value: '4h'
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_el_button, {
                    size: "default",
                    type: "success",
                    onClick: _ctx.submitForm,
                    disabled: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('main.start')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _createVNode(_component_el_button, {
                    size: "default",
                    onClick: _ctx.resetForm,
                    disabled: JSON.stringify(_ctx.calcForm) === JSON.stringify(_ctx.defaultFormData)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('main.reset')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["locale"]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        (_ctx.downloadText)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "item",
              innerHTML: _ctx.downloadText
            }, null, 8, _hoisted_47))
          : _createCommentVNode("", true),
        (_ctx.downloadTimeText)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "item",
              innerHTML: _ctx.downloadTimeText
            }, null, 8, _hoisted_48))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_49, [
        (_ctx.downloadProgress && Number(_ctx.downloadProgress) !== 100)
          ? (_openBlock(), _createBlock(_component_el_progress, {
              key: 0,
              percentage: _ctx.downloadProgress,
              "stroke-width": 15,
              striped: ""
            }, null, 8, ["percentage"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isShowTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.resultsText), 1),
          _createVNode(_component_el_config_provider, { locale: _ctx.locale }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                class: "table",
                data: _ctx.tableData,
                "default-sort": { prop: 'totalProfitPercent', order: 'descending' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.binding'),
                    prop: "binding",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.getBindingText(scope.row.binding) || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.percentEnter'),
                    prop: "percentEnter",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.percentEnter || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.percentExit'),
                    prop: "percentExit",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.percentExit || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.stopLossTime'),
                    prop: "stopLossTime",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.stopLossTime || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.stopLossPercent'),
                    prop: "stopLossPercent",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.stopLossPercent || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.totalDeals'),
                    prop: "totalDeals",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (_ctx.openDealsModal(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.totalDeals || '-') + " (" + _toDisplayString(_ctx.$t('main.table.info')) + ") ", 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.totalProfitPercent'),
                    prop: "totalProfitPercent",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.totalProfitPercent ? `${scope.row.totalProfitPercent}%` : '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.coeff'),
                    prop: "coeff",
                    sortable: true
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.table.coeff')), 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.table.tooltip.coeff')
                          }, null, 8, _hoisted_52)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_53
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.coeff || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.winrate'),
                    prop: "winrate",
                    sortable: true
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.winrate || '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "maxDrawdownPercent",
                    sortable: true,
                    width: 150
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.table.maxDrawdownPercent')), 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.table.tooltip.maxDrawdownPercent')
                          }, null, 8, _hoisted_54)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_55
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.maxDrawdownPercent ? `${scope.row.maxDrawdownPercent}%` : '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "maxTimeInDealMins",
                    sortable: true,
                    width: 130
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.table.maxTimeInDealMins')), 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('main.table.tooltip.maxTimeInDealMins')
                          }, null, 8, _hoisted_56)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_57
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.maxTimeInDealMins || '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('main.table.action'),
                    align: "right",
                    width: 80
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.action) + " ", 1),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (_ctx.createStrategyLink(scope.row)),
                        disabled: scope.row.isShort && (scope.row.exchange === _ctx.Exchange.BINANCE || scope.row.exchange === _ctx.Exchange.OKX)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('main.table.create')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }, 8, ["locale"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DealsModal, {
      modelValue: _ctx.isDealsModalVisible,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.isDealsModalVisible) = $event)),
      dealsRow: _ctx.dealsRow,
      currentResult: _ctx.currentResult
    }, null, 8, ["modelValue", "dealsRow", "currentResult"])
  ]))
}